import { Pipe, PipeTransform } from '@angular/core';
import { DataTransformationService } from '@app/common/data-transformation.service';

@Pipe({
  name: 'formatNhi'
})
export class FormatNhiPipe implements PipeTransform {
  constructor(private dataTransformationService: DataTransformationService) {}

  transform(nhi): string {
    return this.dataTransformationService.getFormattedNHI(nhi);
  }
}
